
import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { SessionManager } from '@services/session-manager';
import { SharedService } from '@services/shared.service';


@Component({
    selector: 'app-test-modal',
    templateUrl: './test-modal.component.html',
    styleUrls: ['./test-modal.component.scss']
})
export class TestModalComponent implements OnInit, OnDestroy {
    @Input() title: string = '';

    @ViewChild('testModal', { static: true }) modal: any;

    isDemoMode = false;

    clickCount = 0;

    intervalId: any;

    constructor(private modalService: NgbModal, public sharedService: SharedService, private router: Router) { }

    ngOnInit() {

        this.isDemoMode = SessionManager.isDemoMode();

        // Limpia los clicks
        this.intervalId = setInterval(() => this.clickCount = 0, 2000);
    }

    ngOnDestroy() {
        if (this.intervalId) { clearInterval(this.intervalId); }
    }

    onToggleDemoMode() {

        SessionManager.setDemoMode(this.isDemoMode);

        if (!this.isDemoMode) {

            this.sharedService.setLoading(true);
            this.closeModal();
            setTimeout(() => {
                this.sharedService.logout();
                this.router.navigate(['/login']);
                this.sharedService.setLoading(false);
            }, 600);
        }
    }

    onShowModal() {

        this.clickCount++;

        if (this.clickCount > 4) {

            this.onOpenModal();

            this.clickCount = 0;
        }
    }

    onOpenModal() {

        this.modalService.open(this.modal, {
            backdrop: 'static', keyboard: false,
            size: 'lg', centered: true, windowClass: 'modal-full'
        });
    }

    closeModal() {

        this.modalService.dismissAll();
    }
}

